import { apiSlice } from "../../app/api/apiSlice";

export const evaluationCriteriaGroupsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEvaluationCriteriaGroups: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/evaluation_criteria_groups/",
        params,
      }),
      providesTags: ["EvaluationCriteriaGroup"],
    }),
    fetchEvaluationCriteriaGroupById: builder.query({
      query: (id) => `/api/v1/resources/evaluation_criteria_groups/${id}/`,
      providesTags: (result, error, id) => [
        { type: "EvaluationCriteriaGroup", id },
      ],
    }),
    createEvaluationCriteriaGroup: builder.mutation({
      query: (args) => ({
        url: "/api/v1/resources/evaluation_criteria_groups/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["EvaluationCriteriaGroup"],
    }),
    deleteEvaluationCriteriaGroup: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/evaluation_criteria_groups/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["EvaluationCriteriaGroup"],
    }),
  }),
});

export const {
  useGetEvaluationCriteriaGroupsQuery,
  useFetchEvaluationCriteriaGroupByIdQuery,
  useCreateEvaluationCriteriaGroupMutation,
  useDeleteEvaluationCriteriaGroupMutation,
} = evaluationCriteriaGroupsApiSlice;
